import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";
import ReactImageMagnify from 'react-image-magnify';
import { formatterImage } from "components/Function";
import { getMockups, mockupGetDesign } from "actions/mockupAction";
import { ReactTable } from "components/Table";
import { Link } from "react-router-dom";
import SelectBox from "components/elements/selectBox";
import Loading from "components/Loading";
import Select from "react-select";

const PRODUCT_OPTIONS = {
    "T-SHIRT": ["BLACK", "WHITE", "SPORT GREY", "SAND", "FOREST GREEN", "LIGHT PINK", "NAVY", "MILITARY GREEN", "MAROON", "RED", "ROYAL BLUE", "ASH GREY", "LIGHT BLUE", "CHARCOAL", "DARK HEATHER", "PURPLE", "ORANGE"],
    "YOUTH T-SHIRT": ["BLACK", "WHITE", "IRISH GREEN", "LIGHT PINK", "FOREST GREEN"],
    "SWEATSHIRT": ["BLACK", "WHITE", "SPORT GREY", "SAND", "FOREST GREEN", "LIGHT PINK", "NAVY", "MILITARY GREEN", "MAROON", "RED", "ROYAL BLUE", "ASH GREY", "ORANGE", "DARK HEATHER"],
    "HOODIE": ["BLACK", "WHITE", "SPORT GREY", "SAND", "FOREST GREEN", "LIGHT PINK", "NAVY"],
    "TANK TOP": ["BLACK", "WHITE", "SPORT GREY", "NAVY"],
    "COMFORT COLOR": ["BLACK", "WHITE", "PEPPER", "IVORY", "ESPRESSO", "BLUE SPRUCE", "CRIMSOM", "BAY", "MOSS", "BLUE JEAN", "SEAFOAM", "GREY", "BLOSSOM", "GRAPHITE", "VIOLET"],
    "WASHED": ["BLACK", "GREY"],
    "MUG": ["BLACK", "WHITE"],
    "POSTER-CANVAS": ["BLACK", "WHITE"],
    "BLANKET": ["BLACK", "WHITE"],
    "ORNAMENT": ["BLACK", "WHITE"],
};

const COLOR_HEX = {
    "BLACK": "#000000",
    "WHITE": "#FFFFFF",
    "SPORT GREY": "#C0C0C0",
    "SAND": "#F5DEB3",
    "FOREST GREEN": "#228B22",
    "LIGHT PINK": "#FFB6C1",
    "NAVY": "#000080",
    "MILITARY GREEN": "#4B5320",
    "MAROON": "#800000",
    "RED": "#FF0000",
    "ROYAL BLUE": "#4169E1",
    "ASH GREY": "#B2BEB5",
    "LIGHT BLUE": "#ADD8E6",
    "CHARCOAL": "#36454F",
    "DARK HEATHER": "#A9A9A9",
    "PURPLE": "#800080",
    "ORANGE": "#FFA500",
    "IRISH GREEN": "#00A550",
    "PEPPER": "#3C3C3C",
    "IVORY": "#FFFFF0",
    "ESPRESSO": "#4B2E2B",
    "BLUE SPRUCE": "#317873",
    "CRIMSOM": "#DC143C",
    "BAY": "#A3C1AD",
    "MOSS": "#8A9A5B",
    "BLUE JEAN": "#5D8AA8",
    "SEAFOAM": "#93E9BE",
    "GREY": "#808080",
    "BLOSSOM": "#FFD3E0",
    "GRAPHITE": "#383838",
    "VIOLET": "#8F00FF"
};

const ModalAddDesignToMockup = ({ designs_selected, onSubmit, getMockups, mockup, staffs, mockupGetDesign }) => {
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [filter, setFilter] = useState({});
    const [mockups_selected, setMockupsSelected] = useState([]);
    const [productType, setProductType] = useState([]);
    const [productColor, setProductColor] = useState([]);

    const { list, totalsize, isLoading } = mockup;

    useEffect(() => {
        getMockups({ page, sizeperpage: sizePerPage, search: searchText, filter });
    }, [getMockups, page, sizePerPage, searchText, filter]);

    const onClose = () => {
        setIsOpen(false);
    };

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
            setSearchText(searchText);
        } else {
            setPage(page);
            setSizePerPage(sizePerPage);
        }
    };

    const removeSelect = (arr, value) => {
        var i = 0;
        while (i < arr.length) {
            if (arr[i] === value) {
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
        return arr;
    };

    const onSelect = (row, isSelect) => {
        var mockups_selected_tmp = mockups_selected;
        if (isSelect) {
            mockups_selected_tmp.push(row._id);
        } else {
            mockups_selected_tmp = removeSelect(mockups_selected_tmp, row._id);
        }
        var new_arr = JSON.stringify(mockups_selected_tmp);
        setMockupsSelected(JSON.parse(new_arr));
        if (mockups_selected_tmp.length !== 0) {
            // setLoadingSync(false);
        }
        if (mockups_selected_tmp.length === 0) {
            // setLoadingSync(true);
        }
    };

    const onSelectAll = (isSelect, row) => {
        var mockups_selected_tmp = mockups_selected;
        if (isSelect) {
            mockups_selected_tmp = row.map((v, i) => v._id);
        } else {
            mockups_selected_tmp = [];
        }
        setMockupsSelected(mockups_selected_tmp);
        if (mockups_selected_tmp.length !== 0) {
            // setLoadingSync(false);
        }
        if (mockups_selected_tmp.length === 0) {
            // setLoadingSync(true);
        }
    };

    const colorOptions = Object.entries(COLOR_HEX).map(([label, hex]) => ({
        label,
        value: label,
        color: hex
    }));

    const productOptions = Object.keys(PRODUCT_OPTIONS).map((name) => ({
        label: name,
        value: name
    }));

    const formatColorLabel = ({ label, color }) => (
        <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{
                backgroundColor: color,
                width: 16,
                height: 16,
                borderRadius: "50%",
                display: "inline-block",
                marginRight: 10,
                border: "1px solid #ccc"
            }}></span>
            {label}
        </div>
    );

    const selectRow = {
        mode: "checkbox",
        clickToSelect: false,
        selected: mockups_selected,
        onSelect: onSelect,
        onSelectAll: onSelectAll,
        selectionHeaderRenderer: ({ indeterminate, checked, onChange }) => (
            <div className="d-flex">
                <input
                    type="checkbox"
                    ref={(input) => {
                        if (input) {
                            input.indeterminate = indeterminate;
                            input.checked = checked;
                        }
                    }}
                    onChange={onChange}
                />
                <span style={{ marginLeft: '8px' }}>({mockups_selected.length})</span>
            </div>
        ),
    };

    const columns = [
        {
            dataField: "_id",
            text: "",
            sort: true,
            editable: false,
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "preview_mockup",
            text: t("Mockup"),
            sort: true,
            editable: false,
            formatter: (cell, row) => (
                <>
                    <div className="symbol symbol-50px">
                        <Link to={cell} target="_blank"><ReactImageMagnify {...{ smallImage: { alt: "", width: 200, height: 200, src: cell || require("components/assets/media/misc/image.png") }, largeImage: { src: cell || require("components/assets/media/misc/image.png"), width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '300%', height: '300%' }, enlargedImageContainerStyle: { "zIndex": 99 }, className: "cursor-pointer", enlargedImageContainerClassName: "al-zoom-img-cus" }} /></Link>
                    </div>
                </>
            ),
        },
        {
            dataField: "productType",
            text: t("Product Type"),
            sort: true,
            editable: false,
        },
        {
            dataField: "productColor",
            text: t("Product Color"),
            sort: true,
            editable: false,
            formatter: (cell, row) => (
                <>
                    <div className="d-flex align-items-center gap-2 mb-3">
                        <span style={{
                            width: 100,
                            height: 100,
                            backgroundColor: COLOR_HEX[cell] || "#ccc",
                            border: '1px solid #000',
                            display: 'inline-block',
                            borderRadius: 4
                        }} />
                        <span style={{ fontWeight: 'bold' }}>{cell}</span>
                    </div>
                </>
            ),
        },
    ];

    const sizePerPageList = [
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
        {
            text: "150",
            value: 150,
        },
        {
            text: "200",
            value: 200,
        },
        {
            text: "All",
            value: totalsize || 10,
        },
    ];

    const onChangeProductType = (e) => {
        var tier_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilter((prev) => ({
            ...prev,
            productType: tier_tmp || [],
        }));
        setProductType(tier_tmp);
    };

    const onChangeProductColor = (e) => {
        var tier_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilter((prev) => ({
            ...prev,
            productColor: tier_tmp || [],
        }));
        setProductColor(tier_tmp);
    };

    const groupButton = () => {
        return (
            <>
                <div className="mb-5 d-flex">
                    <Select
                        isClearable
                        isMulti
                        name="productType"
                        options={productOptions}
                        className="cotik-select-virtual"
                        classNamePrefix="select"
                        value={productOptions.filter(({ value }) => productType.includes(value))}
                        onChange={(e) => {
                            onChangeProductType(e);
                        }}
                        placeholder={t("Select type ... ")}
                    />
                    <Select
                        isClearable
                        isMulti
                        name="productColor"
                        options={colorOptions}
                        className="cotik-select-virtual"
                        classNamePrefix="select"
                        formatOptionLabel={formatColorLabel}
                        value={colorOptions.filter(({ value }) => productColor.includes(value))}
                        onChange={(e) => {
                            onChangeProductColor(e);
                        }}
                        placeholder={t("Select color ... ")}
                    />
                    <SelectBox
                        options={staffs || []}
                        placeholder="Select staff..."
                        name="filter_staff"
                        value={filter.staff || ""}
                        onChange={(data) => {
                            setFilter((prev) => ({
                                ...prev,
                                staff: data.value || "",
                            }));
                        }}
                    />
                </div>
            </>
        );
    };

    useEffect(() => {
        setTotalSize(totalsize);
    }, [totalsize]);

    const handleSubmit = async () => {
        if (designs_selected?.length !== 0 && mockups_selected?.length !== 0) {
            await mockupGetDesign({ designs_selected, mockups_selected })
        }
        onSubmit?.();
        onClose?.();
    };

    return (
        <Fragment>
            <button
                className="btn btn-sm btn-warning"
                data-bs-toggle="modal"
                data-bs-target="#kt_modal_create_app"
                id="kt_toolbar_primary_button"
                onClick={() => setIsOpen(true)}
            >
                {t("Design To Mockup")}
            </button>
            <Modal
                centered={true}
                fullscreen={true}
                toggle={() => {
                    onClose();
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Select mockup:")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onClose();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <Loading isLoading={isLoading} />
                    <div className="card-body p-9">
                        <div className="al-variants-table">
                            <ReactTable
                                columns={columns}
                                data={list}
                                groupButton={groupButton}
                                handleTableChange={handleTableChange}
                                page={page}
                                sizePerPage={sizePerPage}
                                totalSize={totalSize}
                                alClassName="table-layout-inherit"
                                sizePerPageList={sizePerPageList}
                                isSelectRow={true}
                                selectRow={selectRow}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        onClick={handleSubmit}
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                    >
                        {t("Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
};

ModalAddDesignToMockup.propTypes = {
    formatterImage: PropTypes.func.isRequired,
    getMockups: PropTypes.func.isRequired,
    mockupGetDesign: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
    mockup: state.mockup
});
const mapDispatchToProps = {
    formatterImage,
    getMockups,
    mockupGetDesign,
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddDesignToMockup);
